$(document).ready(function(){
    $(document).on('click','.collection_add_cart',function(e){
      ///e.preventDefault();
      var product_id = $(this).parents().find('#product_id').val();
      var product_variant_id = $(this).parents().find('.variant_id--'+ product_id +'').val();
      var subscription_id = $('select#selling_plan-'+ product_id +' option:selected').val();

      if( subscription_id != 'one_time'){
        var items = {
          items: [
            {
              id: product_variant_id,
              quantity: 1,
              selling_plan: subscription_id
            }
          ]
        }
      }else{
        var items = {
          items: [
            {
              id: product_variant_id,
              quantity: 1
            }
          ]
        }
      }
     jQuery.ajax({
        url:'/cart/add.js', 
        type:'POST', 
        data: items,
        dataType: "json",
        success: function(res){
          window.location.href = "/cart";
        }
      });
    });
  });